module.exports = __webpack_public_path__ + "media/tight_rope.fc5b1d3f.mp3";